export type QuoteCurrencyConversion = {
  quoteCurrency: string;
  baseCurrency: string;
  priceFactor: number;
};

export const PRICE_SUBUNIT_CONVERSIONS: readonly QuoteCurrencyConversion[] = [
  { quoteCurrency: "GBp", baseCurrency: "GBP", priceFactor: 0.01 },
  { quoteCurrency: "ILA", baseCurrency: "ILS", priceFactor: 0.01 },
  { quoteCurrency: "ZAC", baseCurrency: "ZAR", priceFactor: 0.01 },
  { quoteCurrency: "KWF", baseCurrency: "KWD", priceFactor: 0.001 },
] as const;

export const normalizeQuoteCurrencyCode = (
  currency?: string | null
): string | null => {
  const trimmed = currency?.trim() ?? "";
  if (!trimmed) return null;
  if (trimmed === "GBp" || trimmed.toUpperCase() === "GBX") return "GBp";

  const normalized = trimmed.toUpperCase();
  return /^[A-Z]{3}$/.test(normalized) ? normalized : null;
};

export const getPriceSubunitConversion = (
  currency?: string | null
): QuoteCurrencyConversion | null => {
  const normalized = normalizeQuoteCurrencyCode(currency);
  return (
    PRICE_SUBUNIT_CONVERSIONS.find(
      (conversion) => conversion.quoteCurrency === normalized
    ) ?? null
  );
};

export const isPriceSubunitCurrency = (currency?: string | null): boolean =>
  getPriceSubunitConversion(currency) !== null;

export const addDerivedPriceSubunitRates = (
  input: Record<string, number>
): Record<string, number> => {
  const rates = { ...input };
  PRICE_SUBUNIT_CONVERSIONS.forEach((conversion) => {
    const baseRate = rates[conversion.baseCurrency];
    if (Number.isFinite(baseRate) && baseRate > 0) {
      rates[conversion.quoteCurrency] = baseRate * conversion.priceFactor;
    }
  });
  return rates;
};
